<template>
  <div class="d-flex flex-row align-end" :class="rowOrder">
    <optical-cross-image
      v-if="showOpticalCross"
      :dimensions="60"
      :obj="rxObject"
      type="refraction"
      class="d-none d-md-inline-flex"
      :showEyepiece="showEyepiece"
    />
    <div class="flex-grow-1">
      <v-text-field
        class="pt-0 my-0 theInput"
        :rounded="rounded"
        dense
        outlined
        filled
        background-color="#FFF"
        :autofocus="eye == 'od'"
        :label="eyePlaceholder"
        :value="inputValue"
        hide-details="auto"
        @blur="handleChange($event.target.value)"
        @focus="$event.target.select()"
        v-on:keyup.enter="$event.target.blur()"
        :rules="[validRx]"
      ></v-text-field>
      <div v-if="!noMessages" class="d-flex flex-row align-center">
        <div class="mt-1 width100p" style="min-height: 1.5em">
          <div v-for="(message, i) in messages" :key="i" class="messageClass">
            {{ message }}
          </div>
        </div>
        <v-fade-transition>
          <rx-information-popup
            v-if="rxObject && showMoreInfo"
            :rxObj="rxObject"
            class="mx-1"
          ></rx-information-popup>
        </v-fade-transition>
      </div>
    </div>
  </div>
</template>

<script>
import RxMethods from "@/assets/js/cls/RxMethods";
import OpticalCrossImage from "@/components/clStuff/OpticalCrossImage";

/* NOTE: IF CHANGING THINGS HERE CONSIDER CHANGING IN KERATOINPUT.VUE AS WELL */

export default {
  name: "RxInput",
  components: {
    OpticalCrossImage,
    RxInformationPopup: () =>
      import("@/components/clStuff/RxInformationPopup.vue"),
  },
  mixins: [RxMethods],
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    eye: {
      type: String,
      default: "none",
    },
    rxString: {
      type: String,
      default: "",
    },
    showVertexed: null,
    showRxCyl: null,
    showOpticalCross: null,
    showMoreInfo: null,
    crossPosition: {
      // put cross on left or right of input? showOpticalCross must be true
      // if not set, looks at eye: "od" puts cross on left, "os" on right
      type: String,
      default: "",
    },
    vertexDistance: {
      type: Number,
      default: 0.012,
    },
    add: {
      type: Number,
      default: 0,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    showEyepiece: null,
    noMessages: null,
    // emitType: {
    //   type: String,
    //   default: "rx" // can also be "vertexted" if you want to get the vertexed Rx back
    // }
  },
  data: function () {
    return {
      //messages:[],
      rxObject: null,
      validRx: true,
      //rxInputString: "",
    };
  },
  methods: {
    handleChange(val) {
      // console.log(val);
      let rxObject = this.parseRxString(val);
      let noRx = val == "";
      let isValid = true;
      if (noRx) rxObject = null;
      if (!noRx) isValid = this.isValidRx(rxObject);
      if (isValid) {
        this.rxObject = rxObject;
        this.validRx = isValid;
        this.emitRx();
      } else {
        this.validRx = false;
      }
    },
    emitRx() {
      //  add vertex and add powers to rxObject before emitting
      if (this.rxObject) this.rxObject.add = this.add;
      if (this.rxObject) this.rxObject.vertex = this.vertexDistance;
      this.$emit("rxChange", this.rxObject);
    },
  },
  computed: {
    eyePlaceholder: function () {
      if (this.placeholder != "") return this.placeholder;
      if (this.placeholder === "none") return "";
      return this.eye === "os" ? "Left eye Rx" : "Right eye Rx";
    },
    inputValue: function () {
      return this.rxString;
    },
    rowOrder: function () {
      if (this.crossPosition != "" && this.crossPosition == "right")
        return "flex-row-reverse";
      if (this.eye == "os") return "flex-row-reverse";
      return "";
    },
    messages: function () {
      let msg = [];
      if (this.validRx && this.rxObject) {
        if (this.showVertexed && !this.isPlano(this.rxObject)) {
          // console.log("new rxinput message");
          let vMrString = this.prettyString(
            this.diffVertex(this.rxObject, 0, this.vertexDistance)
          );
          msg.push(vMrString + " (vertexed)");
        }
        if (this.showRxCyl && !this.isPlano(this.rxObject)) {
          let cylString = `Cyl: ${this.cylP(
            this.rxObject
          )}D ${this.cylOrientationType(this.rxObject)}`;
          msg.push(cylString);
        }
      } else {
        msg.push("Please enter a valid Rx");
      }
      return msg;
    },
  },
  watch: {
    rxString: function () {
      this.handleChange(this.rxString);
    },
  },
  mounted() {
    if (this.rxString) this.handleChange(this.rxString);
  },
};
</script>

<style scoped>
/* .theInput >>> .v-text-field__details {
  margin-left: 1em;
} */
.messageClass {
  line-height: 15px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 11px;
}
</style>
